<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Accounts</p>
                  <router-link :to="`/accounts`">
                    <div class="dashboard-counts">{{ totalCounts.users }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Downloads</p>
                  <router-link :to="`/downloads`">
                    <div class="dashboard-counts">{{ totalCounts.downloads }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Products</p>
                  <router-link :to="`/products`">
                    <div class="dashboard-counts">{{ totalCounts.products }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 counts">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="m-b-0">Total Brandings</p>
                  <router-link :to="`/branding-and-logo`">
                    <div class="dashboard-counts">{{ totalCounts.brandings }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-md-flex justify-content-between align-items-center">
                <h5>Account Activity</h5>
              </div>
              <div class="m-t-30 account-activity-chart-container" style="height: 300px">
                <AccountActivityChart v-if="activity.downloads.length" :activity="activity"></AccountActivityChart>
                <div class="main-loader" v-else>
                  <MainLoader></MainLoader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h5>Top Products</h5>
              </div>
              <div class="m-t-30">
                <TopProductsChart v-if="topProducts.downloads.length" :topProducts="topProducts"></TopProductsChart>
                <div class="main-loader" v-else>
                  <MainLoader></MainLoader>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <h5>Top Accounts</h5>
              <div class="m-v-35 text-center px-5" style="min-height: 350px">
                <TopAccountsChart v-if="topAccounts.downloads.length" :topAccounts="topAccounts"></TopAccountsChart>
                <div class="main-loader" v-else>
                  <MainLoader></MainLoader>
                </div>
                <!-- <canvas class="ct-chart" id="customer-chart"></canvas> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountActivityChart from '@/components/AccountActivityChart'
import TopProductsChart from '@/components/TopProductsChart'
import TopAccountsChart from '@/components/TopAccountsChart'
export default {
  name: 'Dashboard',
  components: { AccountActivityChart, TopProductsChart, TopAccountsChart },
  data () {
    return {
      totalCounts: {
        'users': '...',
        'downloads': '...',
        'products': '...',
        'brandings': '...'
      },
      topProducts: {
        productNames: [],
        downloads: []
      },
      topAccounts: {
        usernames: [],
        downloads: []
      },
      activity: {
        months: [],
        downloads: []
      }
    }
  },
  mounted () {
    this.fetchTotalCounts()
    this.fetchTopProducts()
    this.fetchTopAccounts()
    this.fetchActivity()
  },
  methods: {
    fetchTotalCounts () {
      this.$store.dispatch('fetchTotalCounts')
        .then((result) => {
          this.totalCounts = result.data.counts
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetchTopProducts () {
      this.$store.dispatch('fetchTopProducts')
        .then((result) => {
          this.topProducts.productNames = []
          this.topProducts.downloads = []
          result.data.top_products.forEach(element => {
            this.topProducts.productNames.push(element.name)
            this.topProducts.downloads.push(element.downloads)
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetchTopAccounts () {
      this.$store.dispatch('fetchTopAccounts')
        .then((result) => {
          this.topAccounts.usernames = []
          this.topAccounts.downloads = []
          result.data.top_accounts.forEach(element => {
            this.topAccounts.usernames.push(element.username)
            this.topAccounts.downloads.push(element.downloads)
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetchActivity () {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      this.$store.dispatch('fetchActivity')
        .then((result) => {
          this.activity.months = []
          this.activity.downloads = []
          result.data.activity.forEach(element => {
            this.activity.months.push(monthNames[element.month - 1])
            this.activity.downloads.push(element.downloads)
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}
</script>

<style scoped>
.main-loader {
    height: calc(59vh - 73px);
}
.account-activity-chart-container {
  flex-grow: 1;
  min-height: 0;
}
.account-activity-chart-container > div {
  position: relative;
  height: 100%;
}
.card-body {
  padding: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue